var _defs, _path, _path2, _rect, _path3, _path4, _path5, _rect2, _path6, _rect3, _path7, _rect4, _path8, _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsitesDrawIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "websites-draw-icon_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 70.87 70.87"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".websites-draw-icon_svg__cls-1,.websites-draw-icon_svg__cls-3{fill:#010101;stroke-width:0}.websites-draw-icon_svg__cls-3{fill:#e84b0f}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.34 23.03c1.16 11.7-8.59 21.45-20.29 20.29-8.66-.86-15.66-7.86-16.52-16.52-1.16-11.7 8.59-21.45 20.29-20.29 8.66.86 15.66 7.86 16.52 16.52z",
    fill: "#f9d8cd",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M19.48 51.57l-8.87-11.08L22 28.77l-6.9-17.19 28.18 2.22 1.97 27.57 15.92 9.57L44.19 62.2 29.5 52.64"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "websites-draw-icon_svg__cls-3",
    x: 19.75,
    y: 26.4,
    width: 4.49,
    height: 4.49,
    rx: 1.91,
    ry: 1.91
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-1",
    d: "M22.33 27.4c.52 0 .91.39.91.91v.67c0 .52-.39.91-.91.91h-.67c-.52 0-.91-.39-.91-.91v-.67c0-.52.39-.91.91-.91h.67m0-2h-.67c-1.63 0-2.91 1.28-2.91 2.91v.67c0 1.63 1.28 2.91 2.91 2.91h.67c1.63 0 2.91-1.28 2.91-2.91v-.67c0-1.63-1.28-2.91-2.91-2.91z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-3",
    d: "M10.43 38.25h.67c1.05 0 1.91.86 1.91 1.91v.67c0 1.05-.86 1.91-1.91 1.91h-.67c-1.05 0-1.91-.86-1.91-1.91v-.67c0-1.05.86-1.91 1.91-1.91z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-1",
    d: "M11.1 39.25c.52 0 .91.39.91.91v.67c0 .52-.39.91-.91.91h-.67c-.52 0-.91-.39-.91-.91v-.67c0-.52.39-.91.91-.91h.67m0-2h-.67c-1.63 0-2.91 1.28-2.91 2.91v.67c0 1.63 1.28 2.91 2.91 2.91h.67c1.63 0 2.91-1.28 2.91-2.91v-.67c0-1.63-1.28-2.91-2.91-2.91z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "websites-draw-icon_svg__cls-3",
    x: 17.23,
    y: 49.33,
    width: 4.49,
    height: 4.49,
    rx: 1.91,
    ry: 1.91
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-1",
    d: "M19.81 50.33c.52 0 .91.39.91.91v.67c0 .52-.39.91-.91.91h-.67c-.52 0-.91-.39-.91-.91v-.67c0-.52.43-.91.91-.91h.67m0-2h-.67c-1.61 0-2.91 1.31-2.91 2.91v.67c0 1.63 1.28 2.91 2.91 2.91h.67c1.63 0 2.91-1.28 2.91-2.91v-.67c0-1.63-1.28-2.91-2.91-2.91z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "websites-draw-icon_svg__cls-3",
    x: 12.83,
    y: 9.34,
    width: 4.49,
    height: 4.49,
    rx: 1.91,
    ry: 1.91
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-1",
    d: "M15.41 10.34c.52 0 .91.39.91.91v.67c0 .52-.39.91-.91.91h-.67c-.52 0-.91-.39-.91-.91v-.67c0-.52.39-.91.91-.91h.67m0-2h-.67c-1.63 0-2.91 1.28-2.91 2.91v.67c0 1.63 1.28 2.91 2.91 2.91h.67c1.63 0 2.91-1.28 2.91-2.91v-.67c0-1.63-1.28-2.91-2.91-2.91z"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "websites-draw-icon_svg__cls-3",
    x: 40.79,
    y: 11.5,
    width: 4.49,
    height: 4.49,
    rx: 1.91,
    ry: 1.91
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-1",
    d: "M43.37 12.5c.52 0 .91.39.91.91v.67c0 .52-.39.91-.91.91h-.67c-.52 0-.91-.39-.91-.91v-.67c0-.52.39-.91.91-.91h.67m0-2h-.67c-1.63 0-2.91 1.28-2.91 2.91v.67c0 1.63 1.28 2.91 2.91 2.91h.67c1.63 0 2.91-1.28 2.91-2.91v-.67c0-1.63-1.28-2.91-2.91-2.91z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "websites-draw-icon_svg__cls-3",
    x: 43.07,
    y: 39.13,
    width: 4.49,
    height: 4.49,
    rx: 1.91,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-1",
    d: "M45.65 40.13c.52 0 .91.39.91.91v.67c0 .52-.39.91-.91.91h-.67c-.52 0-.91-.39-.91-.91v-.67c0-.52.43-.91.91-.91h.67m0-2h-.67c-1.61 0-2.91 1.31-2.91 2.91v.67c0 1.63 1.28 2.91 2.91 2.91h.67c1.63 0 2.91-1.28 2.91-2.91v-.67c0-1.63-1.28-2.91-2.91-2.91z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "websites-draw-icon_svg__cls-3",
    x: 58.86,
    y: 48.6,
    width: 4.49,
    height: 4.49,
    rx: 1.91,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-1",
    d: "M61.44 49.6c.52 0 .91.39.91.91v.67c0 .52-.39.91-.91.91h-.67c-.52 0-.91-.39-.91-.91v-.67c0-.52.43-.91.91-.91h.67m0-2h-.67c-1.61 0-2.91 1.31-2.91 2.91v.67c0 1.63 1.28 2.91 2.91 2.91h.67c1.63 0 2.91-1.28 2.91-2.91v-.67c0-1.63-1.28-2.91-2.91-2.91z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-3",
    d: "M43.95 59.96h.67c1.05 0 1.91.86 1.91 1.91v.67c0 1.05-.86 1.91-1.91 1.91h-.67c-1.05 0-1.91-.86-1.91-1.91v-.67c0-1.05.86-1.91 1.91-1.91z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-1",
    d: "M44.62 60.96c.52 0 .91.39.91.91v.67c0 .52-.39.91-.91.91h-.67c-.52 0-.91-.39-.91-.91v-.67c0-.52.39-.91.91-.91h.67m0-2h-.67c-1.63 0-2.91 1.28-2.91 2.91v.67c0 1.63 1.28 2.91 2.91 2.91h.67c1.63 0 2.91-1.28 2.91-2.91v-.67c0-1.63-1.28-2.91-2.91-2.91z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "websites-draw-icon_svg__cls-3",
    x: 27.28,
    y: 50.57,
    width: 4.49,
    height: 4.49,
    rx: 1.91,
    ry: 1.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "websites-draw-icon_svg__cls-1",
    d: "M29.86 51.57c.52 0 .91.39.91.91v.67c0 .52-.39.91-.91.91h-.67c-.52 0-.91-.39-.91-.91v-.67c0-.52.43-.91.91-.91h.67m0-2h-.67c-1.61 0-2.91 1.31-2.91 2.91v.67c0 1.63 1.28 2.91 2.91 2.91h.67c1.63 0 2.91-1.28 2.91-2.91v-.67c0-1.63-1.28-2.91-2.91-2.91z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#010101",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.34 49.81l-6.83 1.73 1.73-6.83L45.8 20.15c.36-.36.94-.36 1.28 0l3.83 3.83c.36.36.36.94 0 1.28L26.35 49.82h0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.87 28.28l-5.1-5.1 3.04-3.04c.36-.36.94-.36 1.28 0l3.83 3.83c.36.36.36.94 0 1.28l-3.04 3.04z",
    fill: "#e84b0f"
  }))));
}
export default SvgWebsitesDrawIcon;